<template>
	<!-- 监理新周报 -->
	<div class="mod-config">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" :inline="true" class="border-form">
			<el-card style="height: 100%;">
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="工程名称" class="item">
							<el-input class="sp-input" v-model="dataForm.projectName" placeholder="请输入"
								v-if="basicVisible">
							</el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.projectName }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="120px" label="报告编号" class="item">
							<el-input class="sp-input" v-model="dataForm.weeklyName" placeholder="请输入"
								v-if="basicVisible">
							</el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.weeklyName }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="委托单位" class="item">
							<el-input class="sp-input" v-model="dataForm.projectEntrust" placeholder="请输入"
								v-if="basicVisible"></el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.projectEntrust }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="120px" label="日期" class="item">
							<span class="set_span">
								{{ dataForm.weeklyTime }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="建造单位" class="item">
							<el-input class="sp-input" v-model="dataForm.contractCompany" placeholder="请输入"
								v-if="basicVisible"></el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.contractCompany }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="120px" label="工作控制号" class="item">
							<span class="set_span">
								{{ dataForm.workNo }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="报告人" class="item">
							<el-input class="sp-input" v-model="dataForm.reportMan" placeholder="请输入"
								v-if="basicVisible"></el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.reportMan }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="120px" label="项目总监" class="item">
							<el-input class="sp-input" v-model="dataForm.projectDirector" placeholder="请输入"
								v-if="basicVisible"></el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.projectDirector }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="23" class="selBtnGroup">
						<el-button class="btn" type="primary" size="small" @click="updateBasicHandle()"
							v-if="!basicVisible">修改</el-button>
						<el-button class="btn" type="primary" size="small" @click="saveBasicHandle()"
							v-if="basicVisible">保存</el-button>
						<el-button class="rebtn" size="small" @click="basicVisible = false"
							v-if="basicVisible">取消</el-button>
					</el-col>
				</el-row>
				<div class="titleDiv">一、本周监理工作概述</div>
				<div class="seTitleDiv">1.基本概况</div>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0" class="title_item">
							<span class="summaryLabelspan">1.1本周生产进度</span>
							<el-radio-group v-model="dataForm.productProgressStatus" @change="saveBasicHandle()">
								<el-radio label="0">正常</el-radio>
								<el-radio label="1">缓慢</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0" class="title_item">
							<span class="summaryLabelspan statusSpan">总体进度</span>
							<el-radio-group v-model="dataForm.overallProgressStatus" @change="saveBasicHandle()">
								<el-radio label="0">正常</el-radio>
								<el-radio label="1">缓慢</el-radio>
								<el-radio label="2">已延期</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0" class="title_item">
							<span class="summaryLabelspan">1.2本周工程质量状况</span>
							<el-radio-group v-model="dataForm.weekQualityStatus" @change="saveBasicHandle()">
								<el-radio label="0">正常</el-radio>
								<el-radio label="1">不满意</el-radio>
								<el-radio label="2">待改进</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0" class="title_item">
							<span class="summaryLabelspan">1.3本周发出监理工作联系单共 {{ dataForm.contactNum }} 份</span>
							<!-- <div class="summaryvalueDiv">
								<span> </span>
							</div> -->
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0" class="title_item">
							<span class="summaryLabelspan">1.4本周文件签收共 {{ dataForm.fileCheckNum }} 份</span>
							<!-- <div class="summaryvalueDiv">
								<span> </span>
							</div> -->
						</el-form-item>
					</el-col>
				</el-row>
				<!-- <el-row style="margin-top:10px">
					<el-col :span="24" class="summaryLabelspan1">
						<el-form-item label-width="0">
							<span>本周整改项目</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-table class="dataListTable" :data="dataForm.patrolItemRecords" header-align="center" border :span-method="objectTestRecordMethod"
							style="width: 100%;" header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
							<el-table-column prop="subjectNo" label="工程编号" width="120" align="center">
							</el-table-column>
							<el-table-column prop="majorName" label="专业" width="120" align="center">
							</el-table-column>
							<el-table-column prop="applyNum" label="本周内提出整改数" align="center">
							</el-table-column>
							<el-table-column prop="alreadyModifyNum" label="截至本周已整改数" align="center">
							</el-table-column>
							<el-table-column prop="notFinishNum" label="截止本周未整改数 " align="center">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row> -->
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0" class="title_item">
							<span class="summaryLabelspan">1.5本周报验情况</span>
						</el-form-item>
					</el-col>
					<draggable v-model="dataForm.testItemRecordList" @start="onDragStart('010105')" @update="onDragEnd">
						<el-row :span="24" v-for="(testItem, index) in dataForm.testItemRecordList"
							:key="'testItem' + index">
							<el-tooltip
								v-if="testItem.dataKind == undefined || testItem.dataKind == '' || testItem.dataKind == '1'"
								placement="top" effect="light" :content="`${testItem.updUserName} ${testItem.updDate}`"
								:enterable="false">
								<el-col :span="24"
									v-if="testItem.dataKind == undefined || testItem.dataKind == '' || testItem.dataKind == '1'">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(testItem)">
										<el-col :span="22" class="desc_span">
											{{ testItem.fileName }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1" class="operate_col">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="testItem.showButton == 1"
												@click="addOrUpdateSituation(testItem.recNo, '010105')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="testItem.showButton == 1"
												@click="deleteWeeklyReportFile(testItem.recNo, '010105')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in testItem.photoList" :key="'testP' + index1"
											style="margin-top: 20px;"
											v-if="testItem.photoList != undefined && testItem.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
							<el-col :span="24"
								v-else-if="testItem.dataKind != undefined && testItem.dataKind != '' && testItem.dataKind == '2' && testItem.showTable == '5'">
								<el-col :span="24" class="cp_sc_div">
									<!-- 左侧文字 -->
									<span>
										<!-- 汇总表 -->
									</span>
									<!-- 右侧关闭按钮 -->
									<el-button type="text" class="desc_btn" style="margin-top:2px"
										@click="deleteWeeklyReportFile(testItem.recNo, '010105')">
										×
									</el-button>
								</el-col>
								<el-table class="dataListTable" :data="testItem.testItemRecords" header-align="center"
									:span-method="(params) => objectTestRecordMethod(params, testItem.testItemRecords)"
									style="width: 100%;margin-left: 10px;font-size: 12px;" border
									:header-cell-style="headClass" header-cell-class-name="dataListTHeader"
									:cell-style="{ padding: '0px' }">
									<el-table-column prop="subjectNo" label="船号" width="120" align="center">
									</el-table-column>
									<el-table-column prop="majorName" label="专业" width="120" align="center">
									</el-table-column>
									<el-table-column prop="testConclusionCount" label="AA" align="center">
										<el-table-column prop="testConclusionCount" label="接受" align="center">
										</el-table-column>
									</el-table-column>
									<el-table-column prop="testConclusionWhereCount" label="QCC" align="center">
										<el-table-column prop="testConclusionWhereCount" label="有条件接受" align="center">
										</el-table-column>
									</el-table-column>
									<el-table-column prop="recheckAfterCorrectionCount" label="OWC" align="center">
										<el-table-column prop="recheckAfterCorrectionCount" label="修正后复检"
											align="center">
										</el-table-column>
									</el-table-column>
									<el-table-column prop="testConclusionRefuseCount" label="NA" align="center">
										<el-table-column prop="testConclusionRefuseCount" label="不接受" align="center">
										</el-table-column>
									</el-table-column>
									<el-table-column prop="testConclusionTotalCount" label="总计 " align="center">
									</el-table-column>
								</el-table>
							</el-col>
						</el-row>
					</draggable>
					<el-row>
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="添加数据明细表格" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addTestItemTableHandle('010105')">
									<i class="el-icon-s-grid  btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="添加汇总情况" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small" @click="addTestItemSummary()">
									<i class="el-icon-s-data"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0" class="title_item">
							<span class="summaryLabelspan">1.6本周巡视情况</span>
						</el-form-item>
					</el-col>
					<draggable v-model="dataForm.partolItemRecordList" @start="onDragStart('010106')"
						@update="onDragEnd">
						<el-row :span="24" v-for="(patrolItem, index) in dataForm.partolItemRecordList"
							:key="'patrolItem' + index">
							<el-tooltip
								v-if="patrolItem.dataKind == undefined || patrolItem.dataKind == '' || patrolItem.dataKind == '1'"
								placement="top" effect="light"
								:content="`${patrolItem.updUserName} ${patrolItem.updDate}`" :enterable="false">
								<el-col :span="24"
									v-if="patrolItem.dataKind == undefined || patrolItem.dataKind == '' || patrolItem.dataKind == '1'">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(testItem)">
										<el-col :span="22" class="desc_span">
											{{ patrolItem.fileName }}
										</el-col>
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1" class="operate_col">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="patrolItem.showButton == 1"
												@click="addOrUpdateSituation(patrolItem.recNo, '010106')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="patrolItem.showButton == 1"
												@click="deleteWeeklyReportFile(patrolItem.recNo, '010106')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in patrolItem.photoList" :key="'parp' + index1"
											style="margin-top: 20px;"
											v-if="patrolItem.photoList != undefined && patrolItem.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
							<el-col :span="24"
								v-else-if="patrolItem.dataKind != undefined && patrolItem.dataKind != '' && patrolItem.dataKind == '2' && patrolItem.showTable == '6'">
								<el-col :span="24" class="cp_sc_div">
									<!-- 左侧文字 -->
									<span>
										<!-- 汇总表 -->
									</span>
									<!-- 右侧关闭按钮 -->
									<el-button type="text" style="margin-top:2px"
										@click="deleteWeeklyReportFile(patrolItem.recNo, '010106')">
										×
									</el-button>
								</el-col>
								<el-table class="dataListTable" :data="patrolItem.patrolItemRecords"
									header-align="center" border
									:span-method="(params) => objectTestRecordMethod(params, patrolItem.patrolItemRecords)"
									style="width: 100%;" header-cell-class-name="dataListTHeader"
									:cell-style="{ padding: '0px' }">
									<el-table-column prop="subjectNo" label="工程编号" width="120" align="center">
									</el-table-column>
									<el-table-column prop="majorName" label="专业" width="120" align="center">
									</el-table-column>
									<el-table-column prop="applyNum" label="本周内提出整改数" align="center">
									</el-table-column>
									<el-table-column prop="alreadyModifyNum" label="截至本周已整改数" align="center">
									</el-table-column>
									<el-table-column prop="notFinishNum" label="截止本周未整改数 " align="center">
									</el-table-column>
								</el-table>
							</el-col>
						</el-row>
					</draggable>
					<el-row>
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="添加数据明细表格" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addPartolItemTableHandle('010106')">
									<i class="el-icon-s-grid  btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="添加汇总情况" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small" @click="addPatrolItemSummary()">
									<i class="el-icon-s-data"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
					<!-- <el-col :span="24">
						<span style="margin-left:20px;color:black"> 共{{ dataForm.inspectionTotalCount }}项：日常巡视，{{
							dataForm.inspectionDailyCount }}项，
							材料试验，{{ dataForm.inspectionMaterialCount }}项，热处理，{{ dataForm.inspectionHeatCount }}项，
							无损探伤，{{ dataForm.inspectionNoDamageCount }}项，消除应力，{{ dataForm.inspectionStressCount }}项。
						</span>
					</el-col> -->
				</el-row>
				<div class="seTitleDiv" style="margin-top:10px">
					<span>2.综合情况及重点关注评述</span>
				</div>
				<el-row style="margin-top: 5px;">
					<draggable v-model="dataForm.comSituationList" @start="onDragStart('010200')" @update="onDragEnd">
						<el-row :span="24" v-for="(situation, index) in dataForm.comSituationList" :key="'sit' + index">
							<el-tooltip placement="top" effect="light"
								:content="`${situation.updUserName} ${situation.updDate}`" :enterable="false">
								<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(situation)">
										<el-col :span="22" class="desc_span">
											{{ situation.fileName }}
										</el-col>
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1" class="operate_col">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="situation.showButton == 1"
												@click="addOrUpdateSituation(situation.recNo, '010200')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="situation.showButton == 1"
												@click="deleteWeeklyReportFile(situation.recNo, '010200')">
												×
											</el-button>
										</el-col>
									</el-col>
									<!-- <el-col :span="24">
										<div v-for="(photo, index1) in situation.photoList" :key="'sip' + index1"
											style="margin-top: 20px;">
											<el-col :span="24" style="margin-left:20px;">
												<el-image style="min-height: 220px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</el-col>
										</div>
									</el-col> -->
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in situation.photoList" :key="'sip' + index1"
											style="margin-top: 20px;"
											v-if="situation.photoList != undefined && situation.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '010200')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('010200')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div class="titleDiv">二、本周进度情况</div>
				<el-row :span="24" v-for="(progressKind, index) in dataForm.progressKindList" :key="'pk' + index">
					<div class="seTitleDiv" style="margin-top:10px">
						<span>{{ progressKind.titleName }}</span>
					</div>
					<el-row style="margin-top: 5px;">
						<draggable v-model="progressKind.recordAndTableList" @start="onDragStart(progressKind.dataType)"
							@update="onDragEnd">
							<el-row :span="24" v-for="(recordTable, index) in progressKind.recordAndTableList"
								:key="'sit' + index">
								<el-tooltip
									v-if="recordTable.dataKind == undefined || recordTable.dataKind == '' || recordTable.dataKind == '1'"
									placement="top" effect="light"
									:content="`${recordTable.record.updUserName} ${recordTable.record.updDate}`"
									:enterable="false">
									<el-col :span="24"
										v-if="recordTable.dataKind == undefined || recordTable.dataKind == '' || recordTable.dataKind == '1'">
										<el-col :span="1">
											<i class="el-icon-position"></i>
										</el-col>
										<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(recordTable.record)">
											<el-col :span="22" class="desc_span">
												{{ recordTable.record.fileName }}
											</el-col>
											<!-- <el-col :span="4" class="un_col">
												<span class="un_span"
													v-if="recordTable.record.updUserName != undefined && recordTable.record.updUserName != '' && recordTable.record.updDate != undefined && recordTable.record.updDate != ''">
													{{ recordTable.record.updUserName }} {{ recordTable.record.updDate
													}}
												</span>
											</el-col> -->
											<!-- 占位 -->
											<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
											</el-button>
											<el-col :span="1" class="operate_col">
												<el-button type="text" style="margin-right: 10px;" class="desc_btn"
													v-if="recordTable.record.showButton == 1"
													@click="addOrUpdateSituation(recordTable.record.recNo, progressKind.dataType, progressKind.progressKindName)">
													<i class="el-icon-edit"></i></el-button>
												<el-button type="text" class="desc_btn"
													v-if="recordTable.record.showButton == 1"
													@click="deleteWeeklyReportFile(recordTable.record.recNo, progressKind.dataType)">
													×
												</el-button>
											</el-col>
										</el-col>
										<!-- <el-col :span="24">
											<div v-for="(photo, index1) in recordTable.record.photoList"
												:key="'prop' + index1" style="margin-top: 20px;">
												<el-col :span="24" style="margin-left:20px;">
													<el-image style="min-height: 220px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</el-col>
											</div>
										</el-col> -->
										<el-col :span="23" style="width:90%;margin-left:170px">
											<div v-for="(photo, index1) in recordTable.record.photoList"
												:key="'prop' + index1" style="margin-top: 20px;"
												v-if="recordTable.record.photoList != undefined && recordTable.record.photoList.length > 0">
												<el-col :span="9">
													<div style="margin:20px 20px 20px 20px ">
														<el-image style="height: 250px;" :src="photo.compressedPathUri"
															fit='contain'></el-image>
													</div>
												</el-col>
											</div>
										</el-col>
									</el-col>
								</el-tooltip>
								<el-col :span="24" v-else-if="recordTable.dataKind != undefined && recordTable.dataKind != '' && recordTable.dataKind == '2'
									&& recordTable.showTable != undefined && recordTable.showTable != '' && recordTable.showTable == '3'">
									<el-row>
										<el-col :span="24" class="cp_sc_div">
											<!-- 左侧文字 -->
											<span>
												<!-- {{ recordTable.conProgress.majorName }} - {{recordTable.conProgress.itemName }} -->
											</span>
											<!-- 右侧关闭按钮 -->
											<el-button type="text" style="margin-top:2px"
												@click="deleteWeeklyReportFile(recordTable.conProgress.recNo, progressKind.dataType)">
												×
											</el-button>
										</el-col>
										<el-table :row-class-name="tableRowClassName" ref="dataListTable"
											class="dataListTable" border :header-cell-style="headClass"
											v-if="recordTable.conProgress.progress.headers != undefined && recordTable.conProgress.progress.headers.length > 0"
											:data="recordTable.conProgress.progress.recordList" header-align="center"
											header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }"
											style="margin-left:10px;font-size: 12px;">
											<el-table-column label="NO." width="60" align="center" type="index">
											</el-table-column>
											<el-table-column
												v-for="(v, idx) in recordTable.conProgress.progress.headers"
												v-if="idx == 0" :key="idx" :label="v.subProgressName" :prop="v.colName"
												align="center" min-width="120px">
												<template slot-scope="scope">
													<span>{{ scope.row.itemName }}</span>
												</template>
											</el-table-column>
											<el-table-column
												v-for="(v, idx) in recordTable.conProgress.progress.headers"
												v-if="recordTable.conProgress.progress.headers.length > 1 && idx >= 1"
												:key="idx" :label="v.subProgressName" :prop="v.colName" align="center"
												>
												<template slot-scope="scope">
													<span>{{ scope.row.contentList[idx].colValue }}</span>
												</template>
											</el-table-column>
											<el-table-column label="备注" align="center">
												<template slot-scope="scope">
													<span>{{ scope.row.remark }}</span>
												</template>
											</el-table-column>
										</el-table>
									</el-row>
								</el-col>
								<el-col :span="24" v-else-if="recordTable.dataKind != undefined && recordTable.dataKind != '' && recordTable.dataKind == '2'
									&& recordTable.showTable != undefined && recordTable.showTable != '' && recordTable.showTable == '4'">
									<el-row>
										<el-col :span="24" class="cp_sc_div">
											<!-- 左侧文字 -->
											<span>
												<!-- {{ recordTable.conProgress.majorName }} - {{recordTable.conProgress.itemName }} -->
											</span>
											<!-- 右侧关闭按钮 -->
											<el-button type="text" style="margin-top:2px"
												@click="deleteWeeklyReportFile(recordTable.recNo, progressKind.dataType)">
												×
											</el-button>
										</el-col>
										<el-table max-height="600" :row-class-name="tableRowClassName"
											:span-method="(params) => objectNodeSpanMethod(params, recordTable.progressNode.records)"
											ref="dataListTable" class="dataListTable" border
											:data="recordTable.progressNode.records" header-align="center"
											header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }"
											:header-cell-style="headClass" style="margin-left:10px;font-size: 12px;">
											<el-table-column v-for="(v, idx) in recordTable.progressNode.headers"
												:key="idx"
												v-if="recordTable.progressNode.headers != undefined && recordTable.progressNode.headers.length > 0 && v.nodeId === '0'"
												:label="v.nodeName" :prop="v.nodeId" align="center" width="130px">
												<template slot-scope="scope">
													<span style="font-weight:bolder">
														{{ scope.row.subjectName }}
													</span>
												</template>
											</el-table-column>
											<el-table-column v-for="(v, idx) in recordTable.progressNode.headers"
												:key="idx"
												v-if="recordTable.progressNode.headers != undefined && recordTable.progressNode.headers.length > 0 && v.nodeId === '1'"
												:label="v.nodeName" :prop="v.nodeId" align="center" width="60px">
												<template slot-scope="scope">
													<span style="font-weight:bolder">
														{{ scope.row.title }}
													</span>
												</template>
											</el-table-column>
											<el-table-column v-for="(v, idx) in recordTable.progressNode.headers"
												:key="idx"
												v-if="recordTable.progressNode.headers != undefined && recordTable.progressNode.headers.length > 0 && idx > 1"
												:label="v.nodeName" :prop="v.nodeId" align="center">
												<template slot-scope="scope">
													<span>
														{{ scope.row.contentList[idx - 2].colValue }}
													</span>
												</template>
											</el-table-column>
										</el-table>
									</el-row>
								</el-col>
							</el-row>
						</draggable>
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="进度对比表" placement="top" effect="light"
								v-if="progressKind.progressKindId === '01'">
								<el-button class="week_btn" type="primary" size="small"
									@click="addProgressRecordHandle(progressKind.dataType)">
									<i class="el-icon-s-marketing btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="添加内容描述" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', progressKind.dataType, progressKind.progressKindName)">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="选择描述内容" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="chooseProgressKindHandle(progressKind.dataType, progressKind.progressKindId, progressKind.progressKindName)">
									<i class="el-icon-search btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="添加表格" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addProgressKindTableHandle(progressKind.dataType, progressKind.progressKindId)">
									<i class="el-icon-s-grid  btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle(progressKind.dataType, progressKind.progressKindName)">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
				</el-row>
				<div class="titleDiv">三、本周质量情况
				</div>
				<el-row style="margin-bottom: 5px;">
					<div class="seTitleDiv">
						<span>1.停止点检查情况：</span>
					</div>
				</el-row>
				<draggable v-model="dataForm.stopPointList" @start="onDragStart('030100')" @update="onDragEnd">
					<el-row :span="24" v-for="(stopPoint, index) in dataForm.stopPointList" :key="'stop' + index">
						<el-tooltip
							v-if="stopPoint.dataKind == undefined || stopPoint.dataKind == '' || stopPoint.dataKind == '1'"
							placement="top" effect="light" :content="`${stopPoint.updUserName} ${stopPoint.updDate}`"
							:enterable="false">
							<el-col :span="24"
								v-if="stopPoint.dataKind == undefined || stopPoint.dataKind == '' || stopPoint.dataKind == '1'">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(stopPoint)">
									<el-col :span="22" class="desc_span">
										{{ stopPoint.fileName }}
									</el-col>
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="stopPoint.showButton == 1"
											@click="addOrUpdateSituation(stopPoint.recNo, '030100')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="stopPoint.showButton == 1"
											@click="deleteWeeklyReportFile(stopPoint.recNo, '030100')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in stopPoint.photoList" :key="'stp' + index1"
										style="margin-top: 20px;"
										v-if="stopPoint.photoList != undefined && stopPoint.photoList.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
						<el-col :span="24"
							v-else-if="stopPoint.dataKind != undefined && stopPoint.dataKind != '' && stopPoint.dataKind == '2' && stopPoint.showTable == '1'">
							<el-col :span="24" class="cp_sc_div">
								<!-- 左侧文字 -->
								<span>
									<!-- 汇总表 -->
								</span>
								<!-- 右侧关闭按钮 -->
								<el-button type="text" class="desc_btn" style="margin-top:2px"
									@click="deleteWeeklyReportFile(stopPoint.recNo, '030100')">
									×
								</el-button>
							</el-col>
							<el-table :row-class-name="tableRowClassName" ref="dataListTable" class="dataListTable"
								border :header-cell-style="headClass" :data="stopPoint.testRecordList"
								header-align="center" header-cell-class-name="dataListTHeader"
								:cell-style="{ padding: '0px' }" style="margin-left:10px;font-size: 12px;">
								<el-table-column label="NO." width="60" align="center" type="index">
								</el-table-column>
								<el-table-column prop="partsName" label="部件" align="left" width="100">
								</el-table-column>
								<el-table-column prop="probContext" label="报验内容" align="left" min-width="150">
								</el-table-column>
								<el-table-column prop="testConclusionName" label="结果" align="left" width="120">
								</el-table-column>
								<el-table-column prop="sutContent" label="报验情况" align="left" min-width="150">
								</el-table-column>
								<el-table-column label="备注" width="200" align="center">
									<template slot-scope="scope">
										<span>{{ scope.row.remark }}</span>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加内容描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '030100')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="添加数据明细表格" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addStopPointTableHandle('030100')">
								<i class="el-icon-s-grid  btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('030100')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row style="margin-bottom: 5px;">
					<div class="seTitleDiv" style="margin-top:10px">
						<span>2.巡检情况：</span>
					</div>
				</el-row>
				<draggable v-model="dataForm.inspectionSituationList" @start="onDragStart('030200')"
					@update="onDragEnd">
					<el-row :span="24" v-for="(inspection, index) in dataForm.inspectionSituationList"
						:key="'inspection' + index">
						<el-tooltip
							v-if="inspection.dataKind == undefined || inspection.dataKind == '' || inspection.dataKind == '1'"
							placement="top" effect="light" :content="`${inspection.updUserName} ${inspection.updDate}`"
							:enterable="false">
							<el-col :span="24"
								v-if="inspection.dataKind == undefined || inspection.dataKind == '' || inspection.dataKind == '1'">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(inspection)">
									<el-col :span="22" class="desc_span">
										{{ inspection.fileName }}
									</el-col>
									<!-- 占位 -->
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="inspection.showButton == 1"
											@click="addOrUpdateSituation(inspection.recNo, '030200')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="inspection.showButton == 1"
											@click="deleteWeeklyReportFile(inspection.recNo, '030200')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in inspection.photoList" :key="'inp' + index1"
										style="margin-top: 20px;"
										v-if="inspection.photoList != undefined && inspection.photoList.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
						<el-col :span="24"
							v-else-if="inspection.dataKind != undefined && inspection.dataKind != '' && inspection.dataKind == '2' && inspection.showTable == '2'">
							<el-col :span="24" class="cp_sc_div">
								<!-- 左侧文字 -->
								<span>
									<!-- 汇总表 -->
								</span>
								<!-- 右侧关闭按钮 -->
								<el-button type="text" class="desc_btn" style="margin-top:2px"
									@click="deleteWeeklyReportFile(inspection.recNo, '030200')">
									×
								</el-button>
							</el-col>
							<el-table :row-class-name="tableRowClassName" ref="dataListTable" class="dataListTable"
								border :header-cell-style="headClass" :data="inspection.inspectionList"
								header-align="center" header-cell-class-name="dataListTHeader"
								:cell-style="{ padding: '0px' }" style="margin-left:10px;font-size: 12px;">
								<el-table-column label="NO." width="60" align="center" type="index">
								</el-table-column>
								<el-table-column prop="sutContent" label="巡检发现的问题及整改意见" align="left" min-width="200">
								</el-table-column>
								<el-table-column prop="inspectionTimeStr" label="提出时间" align="center" width="150">
								</el-table-column>
								<el-table-column prop="closeTimeStr" label="封闭时间" align="center" width="150">
								</el-table-column>
								<el-table-column prop="closeMan" label="封闭人" align="center" width="150">
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加内容描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '030200')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="添加数据明细表格" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addInspectionTableHandle('030200')">
								<i class="el-icon-s-grid  btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('030200')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row style="margin-bottom: 5px;">
					<div class=" seTitleDiv" style="margin-top:10px">
						<span>3.监理工作联系单和通知单（不一致项报告）处理及跟踪情况：</span>
					</div>
				</el-row>
				<draggable v-model="dataForm.contactAndNoticeList" @start="onDragStart('030300')" @update="onDragEnd">
					<el-row :span="24" v-for="(contactAndNotice, index) in dataForm.contactAndNoticeList"
						:key="'contactAndNotice' + index">
						<el-tooltip v-if="contactAndNotice.updUserName && contactAndNotice.updDate" placement="top"
							effect="light" :content="`${contactAndNotice.updUserName} ${contactAndNotice.updDate}`"
							:enterable="false">
							<el-col :span="24" style="cursor: pointer;">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(contactAndNotice)">
									<el-col :span="22" class="desc_span">
										{{ contactAndNotice.fileName }}
									</el-col>
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="contactAndNotice.showButton == 1"
											@click="addOrUpdateSituation(contactAndNotice.recNo, '030300')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="contactAndNotice.showButton == 1"
											@click="deleteWeeklyReportFile(contactAndNotice.recNo, '030300')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in contactAndNotice.photoList" :key="'can' + index1"
										style="margin-top: 20px;"
										v-if="contactAndNotice.photoList != undefined && contactAndNotice.photoList.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '030300')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="选择联系单" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="chooseContactHndle('030300', '1')">
								<i class="el-icon-search btn-icon"></i>联系单
							</el-button>
						</el-tooltip>
						<el-tooltip content="选择通知单" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="chooseContactHndle('030300', '2')">
								<i class="el-icon-search btn-icon"></i>通知单
							</el-button>
						</el-tooltip>
						<el-tooltip content="添加汇总情况" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small" @click="addSummaryHandle()">
								<i class="el-icon-s-data"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('030300')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row style="margin-bottom: 5px;">
					<div class="seTitleDiv" style="margin-top:10px">
						<span>4.签收及审查文件情况：</span>
					</div>
				</el-row>
				<draggable v-model="dataForm.fileCheckRecords" @start="onDragStart('030400')" @update="onDragEnd">
					<el-row :span="24" v-for="(fileCheck, index) in dataForm.fileCheckRecords"
						:key="'fileCheck' + index">
						<el-tooltip placement="top" effect="light"
							:content="`${fileCheck.updUserName} ${fileCheck.updDate}`" :enterable="false">
							<el-col :span="24" style="cursor: pointer;">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS"  :style="getFileItemBgStyle(fileCheck)">
									<el-col :span="22" class="desc_span">
										{{ fileCheck.fileName }}
									</el-col>
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="fileCheck.showButton == 1"
											@click="addOrUpdateSituation(fileCheck.recNo, '030400')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="fileCheck.showButton == 1"
											@click="deleteWeeklyReportFile(fileCheck.recNo, '030400')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in fileCheck.photoList" :key="'fc' + index1"
										style="margin-top: 20px;"
										v-if="fileCheck.photoList != undefined && fileCheck.photoList.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '030400')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('030400')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row style="margin-bottom: 5px;">
					<div class="seTitleDiv" style="margin-top:10px">
						<span>5.会议及会谈情况</span>
					</div>
				</el-row>
				<draggable v-model="dataForm.meetingList" @start="onDragStart('030500')" @update="onDragEnd">
					<el-row v-for="(meeting, index) in dataForm.meetingList" :key="'meet' + index">
						<el-tooltip placement="top" effect="light"
							:content="`${meeting.updUserName} ${meeting.updDate}`" :enterable="false">
							<el-col :span="24" style="cursor: pointer;">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(meeting)">
									<el-col :span="22" class="desc_span">
										{{ meeting.fileName }}
									</el-col>
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="meeting.showButton == 1"
											@click="addOrUpdateSituation(meeting.recNo, '030500')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="meeting.showButton == 1"
											@click="deleteWeeklyReportFile(meeting.recNo, '030500')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in meeting.photoList" :key="'meet' + index1"
										style="margin-top: 20px;"
										v-if="meeting.photoList != undefined && meeting.photoList.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -10px 10px; text-align: right;">
						<el-tooltip content="添加会议与座谈内容 " placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '030500')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="从监理会议模块提取 " placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="selectMeetingHandle('030500')">
								<i class="el-icon-search btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('030500')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div class="titleDiv">四、安全生产/HSE情况</div>
				<el-row>
					<draggable v-model="dataForm.hseRecordList" @start="onDragStart('040000')" @update="onDragEnd">
						<el-row v-for="(hseRecord, index) in dataForm.hseRecordList" :key="index">
							<el-tooltip placement="top" effect="light"
								:content="`${hseRecord.updUserName} ${hseRecord.updDate}`" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(hseRecord)">
										<el-col :span="22" class="desc_span">
											{{ hseRecord.fileName }}
										</el-col>
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1" class="operate_col">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="hseRecord.showButton == 1"
												@click="addOrUpdateSituation(hseRecord.recNo, '040000')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="hseRecord.showButton == 1"
												@click="deleteWeeklyReportFile(hseRecord.recNo, '040000')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in hseRecord.photoList" :key="'hse' + index1"
											style="margin-top: 20px;"
											v-if="hseRecord.photoList != undefined && hseRecord.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:5px 20px -10px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '040000')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('040000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div class="titleDiv">五、监理建议或意见（如需时）</div>
				<el-row>
					<draggable v-model="dataForm.opinionList" @start="onDragStart('050000')" @update="onDragEnd">
						<el-row :span="24" v-for="(opinion, index) in dataForm.opinionList" :key="'opinion' + index">
							<el-tooltip placement="top" effect="light"
								:content="`${opinion.updUserName} ${opinion.updDate}`" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(opinion)">
										<el-col :span="22" class="desc_span">
											{{ opinion.fileName }}
										</el-col>
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1" class="operate_col">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="opinion.showButton == 1"
												@click="addOrUpdateSituation(opinion.recNo, '050000')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="opinion.showButton == 1"
												@click="deleteWeeklyReportFile(opinion.recNo, '050000')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in opinion.photoList" :key="'opin' + index1"
											style="margin-top: 20px;"
											v-if="opinion.photoList != undefined && opinion.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:5px 20px -10px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '050000')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('050000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div class="titleDiv">六、现场人员动态表（如需时）</div>
				<el-row>
					<draggable v-model="dataForm.onsitePersonalList" @start="onDragStart('060000')" @update="onDragEnd">
						<el-row :span="24" v-for="(onsite, index) in dataForm.onsitePersonalList"
							:key="'onsite' + index">
							<el-tooltip placement="top" effect="light"
								:content="`${onsite.updUserName} ${onsite.updDate}`" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(onsite)">
										<el-col :span="22" class="desc_span">
											{{ onsite.fileName }}
										</el-col>
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1" class="operate_col">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												@click="addOrUpdateSituation(onsite.recNo, '060000')"><i
													class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn"
												@click="deleteWeeklyReportFile(onsite.recNo, '060000')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in onsite.photoList" :key="'ons' + index1"
											style="margin-top: 20px;"
											v-if="onsite.photoList != undefined && onsite.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:5px 20px -10px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '060000')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('060000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div class="titleDiv">七、下周重点工作计划及安排（如需时）</div>
				<el-row>
					<draggable v-model="dataForm.keyWorkPlansList" @start="onDragStart('070000')" @update="onDragEnd">
						<el-row :span="24" v-for="(keyWork, index) in dataForm.keyWorkPlansList"
							:key="'keyWork' + index">
							<el-tooltip placement="top" effect="light"
								:content="`${keyWork.updUserName} ${keyWork.updDate}`" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(keyWork)">
										<el-col :span="22" class="desc_span">
											{{ keyWork.fileName }}
										</el-col>
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1" class="operate_col">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												@click="addOrUpdateSituation(keyWork.recNo, '070000')"><i
													class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn"
												@click="deleteWeeklyReportFile(keyWork.recNo, '070000')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in keyWork.photoList" :key="'key' + index1"
											style="margin-top: 20px;"
											v-if="keyWork.photoList != undefined && keyWork.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:5px 20px -10px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '070000')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('070000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div class="titleDiv">八、本周附件</div>
				<el-row style="text-align: right;">
					<el-upload class="addFileBox" ref="uploadEnclosureFile" :action="action"
						:http-request="uploadEnclosureFile" style=" display: inline-block;margin-right:10px">
						<el-button class="btn" type="primary" size="small"> 添加本地附件
						</el-button>
					</el-upload>
					<el-button class="btn" type="primary" size="small" @click="selectContactEnclosureFile()"> 添加联系单
					</el-button>
					<el-button class="btn" type="primary" size="small" @click="selectSpecialReportEnclosureFile()">
						添加专题报告 </el-button>
					<el-button class="btn" type="primary" size="small" @click="selectMeetingEnclosureFile('080000')">
						添加会议纪要
					</el-button>
				</el-row>
				<el-row>
					<el-table ref="singleTable" class="dataListTable" :data="dataForm.enclosureFileList"
						header-align="center" :show-header="false" empty-text="无附件"
						header-cell-class-name="dataListTHeader" :border="!!dataForm.enclosureFileList?.length"
						:cell-style="{ padding: '0px' }" row-key="recNo"
						style="width:100%;margin-top:10px;font-size: 12px;"
						:class="{ 'no-data-table': !dataForm.enclosureFileList?.length }">
						<el-table-column type="index" label="No." align="center" width="80" />
						<el-table-column prop="fileName" label="" align="left"/>
						<el-table-column width="200" align="center">
							<template slot-scope="scope">
								<el-button type="text" size="small"
									@click="viewEnclosureFile(scope.row.filePathUri, scope.row.fileName)"
									:disabled="updateFlg || addFlg || basicVisible">查看</el-button>
								<el-button type="text" size="small"
									@click="deleteWeeklyReportFile(scope.row.recNo, '080000')"
									:disabled="updateFlg || addFlg || basicVisible">刪除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-row>
				<div class="titleDiv">九、建造照片</div>
				<el-row>
					<el-button class="btn" type="primary" size="small" @click="selectPhoto()"> 选择照片 </el-button>
				</el-row>
				<el-row>
					<el-col :span="23" style="width:90%;margin-left:170px">
						<div v-for="(photo, index) in dataForm.photoList" :key="'pp' + index"
							v-if="dataForm.photoList != undefined && dataForm.photoList.length > 0"
							:style="{ order: photo.sort }" @dragstart="dragPhotoStart(index)" @dragover.prevent
							@drop="drop(index)" @dragend="dragEnd()" draggable="true">
							<el-col :span="9" class="photo_col">
								<div style="margin:20px 20px 20px 20px ">
									<el-image style="height: 250px;" :src="photo.compressedPathUri"
										fit='contain'></el-image>
									<div class="t-column-ellipsis">
										<span class="report_font">{{ photo.fileName }}</span>
									</div>
									<div style="float:right">
										<el-button type="text" class="button" style="margin-right: 10px;"
											@click="updateImgContent(photo.recNo, photo.fileName)"><i
												class="el-icon-edit"></i></el-button>
										<el-button type="text" class="button"
											@click="deleteWeeklyReportFile(photo.recNo, '090000')">×
										</el-button>
									</div>
								</div>
							</el-col>
						</div>
					</el-col>
				</el-row>
				<!-- <el-row>
					<div class="tr_qp_row" style="margin-bottom:-10px">进度照片</div>
				</el-row>
				<div v-for="(progressPhoto, index) in dataForm.progressPhotoList" :key="'pp' + index">
					<el-row class="cp_row">
						<el-row class="cp_sub_row">
							{{ progressPhoto.subjectName }}
						</el-row>
					</el-row>
					<el-row>
						<el-button class="btn" type="primary" size="small" @click="selectqpPhoto('2', index)"
							:disabled="updateFlg || addFlg || basicVisible"> 选择照片 </el-button>
					</el-row>
					<el-row class="photo_row">
						<el-col :span="23" style="width:90%;margin-left:170px">
							<div v-for="(photo, index1) in progressPhoto.photoList" :key="'pp' + index1"
								v-if="progressPhoto.photoList != undefined && progressPhoto.photoList.length > 0"
								:style="{ order: photo.sort }" @dragstart="dragStart(index, index1)" @dragover.prevent
								@drop="drop(index, index1, '1')" @dragend="dragEnd(index, '1')" draggable="true">
								<el-col :span="9" class="photo_col">
									<div style="margin:20px 20px 20px 20px ">
										<el-image style="height: 250px;" :src="photo.compressedPathUri" fit='contain'></el-image>
										<div class="t-column-ellipsis">
											{{ photo.fileName }}
										</div>
										<div style="float:right">
											<el-button type="text" class="button" style="margin-right: 10px;"
												@click="updateImgContent(photo.recNo, photo.fileName)"
												:disabled="updateFlg || addFlg || basicVisible"><i
													class="el-icon-edit"></i>修改</el-button>
											<el-button type="text" class="button"
												@click="deleteWeeklyReportFile(photo.recNo, '090000')"
												:disabled="updateFlg || addFlg || basicVisible">×
												删除</el-button>
										</div>
									</div>
								</el-col>
							</div>
						</el-col>
					</el-row>
				</div>
				<el-row>
					<div class="tr_qp_row" style="margin-top:10px;margin-bottom:-10px">质量照片</div>
				</el-row>
				<div v-for="(qualityPhoto, index) in dataForm.qualityPhotoList" :key="'qp' + index">
					<el-row class="cp_row">
						<el-row class="cp_sub_row">
							{{ qualityPhoto.subjectName }}
						</el-row>
					</el-row>
					<el-row>
						<el-button class="btn" type="primary" size="small" @click="selectqpPhoto('1', index)"
							:disabled="updateFlg || addFlg || basicVisible"> 选择照片 </el-button>
					</el-row>
					<el-row class="photo_row">
						<el-col :span="23" style="width:90%;margin-left:170px">
							<div v-for="(photo, index1) in qualityPhoto.photoList" :key="'qp' + index1"
								v-if="qualityPhoto.photoList != undefined && qualityPhoto.photoList.length > 0"
								:style="{ order: photo.sort }" @dragstart="dragStart(index, index1)" @dragover.prevent
								@drop="drop(index, index1, '2')" @dragend="dragEnd(index, '2')" draggable="true">
								<el-col :span="9" class="photo_col">
									<div style="margin:20px 20px 20px 20px ">
										<el-image style="height: 250px;" :src="photo.compressedPathUri" fit='contain'></el-image>
										<div class="t-column-ellipsis">
											{{ photo.fileName }}
										</div>
										<div style="float:right">
											<el-button type="text" class="button" style="margin-right: 10px;"
												@click="updateImgContent(photo.recNo, photo.fileName)"
												:disabled="updateFlg || addFlg || basicVisible"><i
													class="el-icon-edit"></i>修改</el-button>
											<el-button type="text" class="button"
												@click="deleteWeeklyReportFile(photo.recNo, '090000')"
												:disabled="updateFlg || addFlg || basicVisible">×
												删除</el-button>
										</div>
									</div>
								</el-col>
							</div>
						</el-col>
					</el-row>
				</div> -->
			</el-card>
		</el-form>

		<!-- 质量进度照片内容修改 -->
		<el-dialog title="修改描述" :visible.sync="updateImgContentVisable" width="30%" :close-on-click-modal="false">
			<el-form>
				<el-row>
					<el-col :span="24">
						<el-form-item label="">
							<el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }"
								v-model="updatePhotoContent" placeholder="请填写" style="width:420px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick class="btn" type="primary" size="small"
					@click="saveImgContent">保存</el-button>
				<el-button v-preventReClick class="rebtn" size="small" @click="updateImgContentVisable = false">取
					消</el-button>
			</span>
		</el-dialog>

		<contact-select v-if="contactSelectVisible" ref="contactSelect"
			@selectContactItems="margeSelectContactItems"></contact-select>
		<special-report-select v-if="specialReportSelectVisible" ref="specialReportSelect"
			@selectSpecialReportItems="margeSelectSpecialReportItems"></special-report-select>
		<meeting-select v-if="meetingSelectVisible" ref="meetingSelect"
			@selectMeetingItems="margeSelectMeetingItems"></meeting-select>
		<photo-select v-if="selectPhotoVisible" ref="photoSelect"
			@selectPhotoItems="margeSelectPhotoItems"></photo-select>
		<add-or-update-meeting v-if="addOrUpdateMeetingVisible" ref="addOrUpdateMeeting"
			@refreshDataList="getWeeklyMeetingList"></add-or-update-meeting>
		<add-or-update-situation v-if="addOrUpdateSituationVisible" ref="addOrUpdateSituation"
			@refreshDataList="getWeeklySituationList"></add-or-update-situation>
		<choose-progress-record v-if="chooseProgressKindVisible" ref="chooseProgressRecord"
			@refreshDataList="getWeeklySituationList"></choose-progress-record>
		<last-record-ref v-if="lastRecordRefVisible" ref="lastRecordRef"
			@refreshDataList="getWeeklySituationList"></last-record-ref>
		<add-progress-table v-if="addProgressKindTableVisible" ref="addProgressTable"
			@refreshDataList="getWeeklySituationList"></add-progress-table>
		<choose-contact v-if="chooseContactVisible" ref="chooseContact"
			@refreshDataList="getWeeklySituationList"></choose-contact>
	</div>
</template>
<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js";
import ContactSelect from './contact-select.vue'
import SpecialReportSelect from './special-report-select .vue'
import MeetingSelect from './meeting-select.vue'
import PhotoSelect from './photo-select.vue'
import AddOrUpdateMeeting from './add-or-update-meeting.vue'
import AddOrUpdateSituation from './add-or-update-situation.vue'
import ChooseProgressRecord from './choose-progress-record.vue'
import LastRecordRef from './last-record-ref.vue'
import AddProgressTable from './add-progress-table.vue'
import ChooseContact from './project-weekly-choose-contact.vue'
import draggable from 'vuedraggable';

export default {
	data() {
		return {
			basicVisible: false,
			addOrUpdateVisible: false,
			contactSelectVisible: false,
			specialReportSelectVisible: false,
			meetingSelectVisible: false,
			selectQPPhotoVisible: false,
			selectPhotoVisible: false,
			photoFlag: 0,
			dialogVisible: false,
			meetPhotoDialogVisible: false,
			meetPhotoListIndex: 0,
			addImg: addImg,
			recNo: '',
			action: '',
			photoList: [],
			meetDescList: [],
			meetPhotoList: [],
			enclosureFileList: [],
			projectDesc: [],
			majorList: [],
			subjectList: {},
			photoPojectNo: '',
			subjectNo: '',
			photoContent: '',
			meetPhotoContent: '',
			workNo: $common.getItem("workNo"),
			dataRule: {},
			dataForm: {
				projectInfo: {
					projectName: ''
				},
				designDrawing: {
					fileList: [],
					progressDescList: []
				},
				equipmentDataReview: {
					fileList: [],
					progressDescList: []
				},
				productionDesign: {
					fileList: [],
					progressDescList: []
				},
				procurementProgress: {
					fileList: [],
					progressDescList: []
				},
				onsiteProductionProgress: {
					fileList: [],
					progressDescList: []
				}
			},
			photoViewCol: 6,
			draggedItem: {},
			draggedPhotoItem: {},
			selectPhotoType: '',
			recNos: [],
			updateImgContentVisable: false,
			addOrUpdateMeetingVisible: false,
			addOrUpdateSituationVisible: false,
			chooseProgressKindVisible: false,
			lastRecordRefVisible: false,
			addProgressKindTableVisible: false,
			chooseContactVisible: false,
			photoType: '',
			photoRecNo: '',
			updatePhotoContent: '',
			contentIdx: '',
			menuId: 'basic',
			nodeList: [],
			headers: [],
			addFlg: false,
			updateFlg: false,
			updateDescRecNo: '',
			qpPhotoIndex: '',
			selectPhotoType: '',
			meetDataType: '',
			updateDataType: '',
			updateIndex: '',
			updateIndex1: '',
			updateIndex2: '',
			refDataType: ''
		};
	},
	components: {
		ContactSelect,
		SpecialReportSelect,
		MeetingSelect,
		PhotoSelect,
		AddOrUpdateMeeting,
		AddOrUpdateSituation,
		draggable,
		ChooseProgressRecord,
		AddProgressTable,
		LastRecordRef,
		ChooseContact,
	},
	mounted() {
		this.recNo = this.$route.query.recNo;
		this.getProjectWeeklyReportInfo()
	},
	methods: {
		getFileItemBgStyle(item) {
			if (item && item.oriRecNo) {
				return { backgroundColor: 'rgb(249 248 209 / 69%)' };
			}
			return {};
		},
		updateBasicHandle() {
			this.basicVisible = true;
		},
		saveBasicHandle() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectweeklyreportinfo/update",
				method: 'post',
				data: this.$http.adornData({
					recNo: this.recNo,
					weeklyName: this.dataForm.weeklyName,
					reportMan: this.dataForm.reportMan,
					reportTime: this.dataForm.reportTime,
					refirmMan: this.dataForm.refirmMan,
					refirmTime: this.dataForm.refirmTime,
					productProgressStatus: this.dataForm.productProgressStatus,
					overallProgressStatus: this.dataForm.overallProgressStatus,
					weekQualityStatus: this.dataForm.weekQualityStatus,
					weekSafeStatus: this.dataForm.weekSafeStatus,
					projectName: this.dataForm.projectName,
					projectEntrust: this.dataForm.projectEntrust,
					contractCompany: this.dataForm.contractCompany,
					reportMan: this.dataForm.reportMan,
					projectDirector: this.dataForm.projectDirector,
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.getProjectWeeklyReportInfo()
					this.basicVisible = false;
				}
			})
		},
		getProjectWeeklyReportInfo() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectweeklyreportinfo/getProjectWeeklyReportInfo/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm = data.body;
					// 主要建造大节点
					// this.nodeList = data.body.nodeInfo.records;
					// this.headers = data.body.nodeInfo.headers;
					// 重新设置附件名称
					let enclosureFiles = []
					if (data.body.enclosureFileList != undefined && data.body.enclosureFileList.length > 0) {
						for (var i = 0; i < data.body.enclosureFileList.length; i++) {
							data.body.enclosureFileList[i].fileName = '附件' + (i + 1) + "：" + data.body.enclosureFileList[i].fileName
							enclosureFiles.push(data.body.enclosureFileList[i]);
						}
					}
					this.dataForm.enclosureFileList = enclosureFiles;

					// 将header名称列改为工程编号
					// this.headers[0].nodeName = '工程编号'
					this.addFlg = false;
					this.updateFlg = false;
					this.updateDescRecNo = '';
				}
			});
		},
		getNodeInfoList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectprogressnoderecord/list/" + $common.getItem("workNo"),
				method: 'get',
				params: this.$http.adornParams({
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.nodeList = data.body.records;
					this.headers = data.body.headers;
					// 将header名称列改为工程编号
					this.headers[0].nodeName = '工程编号'
				}
			})
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableScnenRowClassName({ row, rowIndex });
		},
		flitterSubjectName(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.subjectName === arr[index - 1].subjectName) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		flitterData(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.title === arr[index - 1].title) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		// 建造大节点，合并行
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				// this.tableData  修改
				const _row = (this.flitterSubjectName(this.nodeList).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			} else if (columnIndex === 1) {
				// this.tableData  修改
				const _row = (this.flitterData(this.nodeList).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},
		// 合并单元格方法（接收当前表格数据）
		objectTestRecordMethod({ row, column, rowIndex, columnIndex }, tableData) {
			// 只对第 0 列 工程编号 合并
			if (columnIndex === 0) {
				const spanArr = this.flitterSubjectNo(tableData);
				const _row = spanArr.one[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},

		// 计算需要合并的行数（通用方法）
		flitterSubjectNo(arr) {
			if (!arr || arr.length === 0) {
				return { one: [] };
			}
			let spanOneArr = [];
			let concatOne = 0;

			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					// 根据 subjectNo 相同则合并
					if (item.subjectNo === arr[index - 1].subjectNo) {
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					}
				}
			});

			return {
				one: spanOneArr,
			};
		},
		getCurrentDate() {
			//获取当前时间并打印
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			if (mm < 10) {
				mm = '0' + mm;
			}
			return yy + '.' + mm + '.' + dd;
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		saveWeeklyFileList(weekFileList, dataType) {
			let _url = "/business/projectweeklyreportfile/saveBatch";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					records: weekFileList,
					weeklyRecNo: this.recNo
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					if (dataType === '080000') {
						this.getEnclosureFileList();
					} else if (dataType === '090000') {
						this.getWeeklySituationList()
					} else if (dataType === '010200' || dataType.startsWith("02") || dataType === '030100' || dataType === '030200'
						|| dataType === '030500' || dataType === '030200' || dataType == '030300' || dataType == '030400') {
						this.getWeeklySituationList()
					}
				}
			});
		},
		getWeeklySituationList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectweeklyreportinfo/getWeeklySituationList/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.testItemRecordList = data.body.testItemRecordList
					this.dataForm.partolItemRecordList = data.body.partolItemRecordList
					this.dataForm.comSituationList = data.body.comSituationList
					this.dataForm.stopPointList = data.body.stopPointList
					this.dataForm.inspectionSituationList = data.body.inspectionSituationList
					this.dataForm.progressKindList = data.body.progressKindList
					this.dataForm.hseRecordList = data.body.hseRecordList
					this.dataForm.opinionList = data.body.opinionList
					this.dataForm.onsitePersonalList = data.body.onsitePersonalList
					this.dataForm.keyWorkPlansList = data.body.keyWorkPlansList
					this.dataForm.meetingList = data.body.meetingList
					this.dataForm.fileCheckRecords = data.body.fileCheckRecords
					this.dataForm.contactAndNoticeList = data.body.contactAndNoticeList
					this.dataForm.photoList = data.body.photoList
				}
			});
		},
		saveMeetingFiles(meetIds) {
			// 计算最大排序值
			let sort = 0;
			let meetingList = this.dataForm.meetingList
			if (meetingList != undefined && meetingList.length > 0) {
				for (var i = 0; i < meetingList.length; i++) {
					if (meetingList[i].sort > sort) {
						sort = meetingList[i].sort
					}
				}
			}
			let _url = "/business/projectweeklyreportfile/saveMeetingFiles";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					weeklyRecNo: this.recNo,
					meetIds: meetIds,
					sort: sort + 1
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					// this.getWeeklyMeetingList();
					this.getWeeklySituationList();
				}
			});
		},
		getWeeklyMeetingList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectweeklyreportinfo/getWeeklyMeetingList/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.meetingList = data.body
				}
			});
		},
		getConstructionProgressList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectweeklyreportinfo/getConstructionProgressList/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.constructionProgressList = data.body
				}
			});
		},
		dragPhotoStart(index) {
			this.draggedItem = { index: index };
		},
		drop(index) {
			const x = this.draggedItem.index
			const y = index
			let fileList = this.dataForm.photoList

			if (x == y) {
				return
			} else if (x < y) {
				const item = fileList.splice(x, 1)[0];
				fileList.splice(y, 0, item);
			} else {
				const item = fileList.splice(x, 1)[0];
				fileList.splice(y, 0, item);
			}
		},
		dragEnd() {
			this.draggedItem = {};
			// 保存至db
			let fileList = this.dataForm.photoList
			this.updateDataType = '090000';
			this.weeklyReportSort(fileList)

		},
		weeklyReportSort(fileList) {
			// this.$http({
			// 	url: this.$store.state.httpUrl + "/business/projectweeklyreportfile/sort",
			// 	method: "POST",
			// 	data: this.$http.adornData({
			// 		fileList: reportFile.fileList,
			// 		weeklyRecNo: this.recNo,
			// 		subjectNo: reportFile.subjectNo,
			// 		dataType: reportFile.dataType
			// 	}),
			// }).then(({ data }) => {
			// 	if (data && data.resultCode === 200) {
			// 		this.$message({
			// 			message: '操作成功',
			// 			type: 'success',
			// 			duration: 1500,
			// 			onClose: () => {
			// 				this.getWeeklySituationList()
			// 			}
			// 		})
			// 	}
			// });

			this.$http({
				url: this.$store.state.httpUrl + "/business/projectweeklyreportfile/sort",
				method: "post",
				data: this.$http.adornData({
					dataType: this.updateDataType,
					weeklyRecNo: this.recNo,
					fileList: fileList
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.updateDataType = ''
							this.getWeeklySituationList();
						}
					});
				}
			});
		},
		deleteWeeklyReportFile(recNo, dataType) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/projectweeklyreportfile/delete/" + recNo,
					method: "post",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getEnclosureFileList()
								this.getWeeklySituationList()
							}
						})
					}
				});
			})
		},
		addOrUpdateMeeting(recNo) {
			// 计算最大排序值
			let sort = 0;
			let meetingList = this.dataForm.meetingList
			if (meetingList != undefined && meetingList.length > 0) {
				for (var i = 0; i < meetingList.length; i++) {
					if (meetingList[i].sort > sort) {
						sort = meetingList[i].sort
					}
				}
			}
			this.addOrUpdateMeetingVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdateMeeting.init(this.recNo, recNo, sort + 1)
			})
		},
		// objectNodeSpanMethod({ row, column, rowIndex, columnIndex }, tableData) {
		// 	// 第一列：subjectName 合并
		// 	if (columnIndex === 0) {
		// 		const _row = this.getSpanCount(tableData, rowIndex, 'subjectName');
		// 		const _col = _row > 0 ? 1 : 0;
		// 		return { rowspan: _row, colspan: _col };
		// 	}

		// 	// 第二列：title 合并
		// 	if (columnIndex === 1) {
		// 		const _row = this.getSpanCount(tableData, rowIndex, 'title');
		// 		const _col = _row > 0 ? 1 : 0;
		// 		return { rowspan: _row, colspan: _col };
		// 	}
		// },

		flitterNodeSubjectNo(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.subjectName === arr[index - 1].subjectName) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		flitterNodeData(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.title === arr[index - 1].title) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		objectNodeSpanMethod({ row, column, rowIndex, columnIndex }, tableData) {
			if (columnIndex === 0) {
				// this.tableData  修改
				const _row = (this.flitterNodeSubjectNo(tableData).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			} else if (columnIndex === 1) {
				// this.tableData  修改
				const _row = (this.flitterNodeData(tableData).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},

		// 工具方法：计算相同内容需要合并的行数
		getSpanCount(arr = [], index, key) {
			let count = 1;
			for (let i = index; i < arr.length - 1; i++) {
				if (arr[i][key] === arr[i + 1][key]) {
					count++;
				} else {
					break;
				}
			}
			return count;
		},
		addOrUpdateSituation(recNo, dataType, progressKindName) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			this.addOrUpdateSituationVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdateSituation.init(this.recNo, recNo, sort + 1, dataType, progressKindName)
			})
		},
		getMaxSort(dataType) {
			// 计算最大排序值
			let sort = 0;
			if (dataType === '010200' && this.dataForm.comSituationList != undefined && this.dataForm.comSituationList.length > 0) {
				for (var i = 0; i < this.dataForm.comSituationList.length; i++) {
					if (this.dataForm.comSituationList[i].sort > sort) {
						sort = this.dataForm.comSituationList[i].sort
					}
				}
			} else if (dataType === '010105' && this.dataForm.testItemRecordList != undefined && this.dataForm.testItemRecordList.length > 0) {
				for (var i = 0; i < this.dataForm.testItemRecordList.length; i++) {
					if (this.dataForm.testItemRecordList[i].sort > sort) {
						sort = this.dataForm.testItemRecordList[i].sort
					}
				}
			} else if (dataType === '010106' && this.dataForm.partolItemRecordList != undefined && this.dataForm.partolItemRecordList.length > 0) {
				for (var i = 0; i < this.dataForm.partolItemRecordList.length; i++) {
					if (this.dataForm.partolItemRecordList[i].sort > sort) {
						sort = this.dataForm.partolItemRecordList[i].sort
					}
				}
			} else if (dataType === '030100' && this.dataForm.stopPointList != undefined && this.dataForm.stopPointList.length > 0) {
				for (var i = 0; i < this.dataForm.stopPointList.length; i++) {
					if (this.dataForm.stopPointList[i].sort > sort) {
						sort = this.dataForm.stopPointList[i].sort
					}
				}
			} else if (dataType === '030200' && this.dataForm.inspectionSituationList != undefined && this.dataForm.inspectionSituationList.length > 0) {
				for (var i = 0; i < this.dataForm.inspectionSituationList.length; i++) {
					if (this.dataForm.inspectionSituationList[i].sort > sort) {
						sort = this.dataForm.inspectionSituationList[i].sort
					}
				}
			} else if (dataType === '030300' && this.dataForm.contactAndNoticeList != undefined && this.dataForm.contactAndNoticeList.length > 0) {
				for (var i = 0; i < this.dataForm.contactAndNoticeList.length; i++) {
					if (this.dataForm.contactAndNoticeList[i].sort > sort) {
						sort = this.dataForm.contactAndNoticeList[i].sort
					}
				}
			} else if (dataType === '030400' && this.dataForm.fileCheckRecords != undefined && this.dataForm.fileCheckRecords.length > 0) {
				for (var i = 0; i < this.dataForm.fileCheckRecords.length; i++) {
					if (this.dataForm.fileCheckRecords[i].sort > sort) {
						sort = this.dataForm.fileCheckRecords[i].sort
					}
				}
			} else if (dataType === '030500' && this.dataForm.meetingList != undefined && this.dataForm.meetingList.length > 0) {
				for (var i = 0; i < this.dataForm.meetingList.length; i++) {
					if (this.dataForm.meetingList[i].sort > sort) {
						sort = this.dataForm.meetingList[i].sort
					}
				}
			} else if (dataType === '040000' && this.dataForm.hseRecordList != undefined && this.dataForm.hseRecordList.length > 0) {
				for (var i = 0; i < this.dataForm.hseRecordList.length; i++) {
					if (this.dataForm.hseRecordList[i].sort > sort) {
						sort = this.dataForm.hseRecordList[i].sort
					}
				}
			} else if (dataType === '050000' && this.dataForm.opinionList != undefined && this.dataForm.opinionList.length > 0) {
				for (var i = 0; i < this.dataForm.opinionList.length; i++) {
					if (this.dataForm.opinionList[i].sort > sort) {
						sort = this.dataForm.opinionList[i].sort
					}
				}
			} else if (dataType === '060000' && this.dataForm.onsitePersonalList != undefined && this.dataForm.onsitePersonalList.length > 0) {
				for (var i = 0; i < this.dataForm.onsitePersonalList.length; i++) {
					if (this.dataForm.onsitePersonalList[i].sort > sort) {
						sort = this.dataForm.onsitePersonalList[i].sort
					}
				}
			} else if (dataType === '070000' && this.dataForm.keyWorkPlansList != undefined && this.dataForm.keyWorkPlansList.length > 0) {
				for (var i = 0; i < this.dataForm.keyWorkPlansList.length; i++) {
					if (this.dataForm.keyWorkPlansList[i].sort > sort) {
						sort = this.dataForm.keyWorkPlansList[i].sort
					}
				}
			} else if (dataType.startsWith("02")) {
				for (var i = 0; i < this.dataForm.progressKindList.length; i++) {
					let progressKind = this.dataForm.progressKindList[i];
					if (progressKind.dataType == dataType && progressKind.recordAndTableList != undefined && progressKind.recordAndTableList.length > 0) {
						for (var j = 0; j < progressKind.recordAndTableList.length; j++) {
							let recordAndTable = progressKind.recordAndTableList[j];
							sort = recordAndTable.sort
						}
					}
				}
			}
			return sort;
		},
		chooseProgressKindHandle(dataType, progressKindId, progressKindName) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			this.chooseProgressKindVisible = true;
			this.$nextTick(() => {
				this.$refs.chooseProgressRecord.init(this.recNo, sort + 1, dataType, progressKindId, progressKindName, this.dataForm.beginTime, this.dataForm.endTime)
			})
		},
		lastRecordRefHandle(dataType, progressKindName) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			this.refDataType = dataType;
			this.lastRecordRefVisible = true;
			this.$nextTick(() => {
				this.$refs.lastRecordRef.init(this.recNo, sort + 1, dataType, progressKindName)
			})
		},
		addSummaryHandle() {
			let _url = "/business/projectweeklyreportfile/saveContactAndNoticeSummary";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: this.recNo,
					workNo: $common.getItem("workNo"),
					endTime: this.dataForm.endTime
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getWeeklySituationList();
				}
			});
		},
		addTestItemSummary() {
			let _url = "/business/projectweeklyreportfile/addTestItemSummary";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: this.recNo,
					workNo: $common.getItem("workNo"),
					beginTime: this.dataForm.beginTime,
					endTime: this.dataForm.endTime
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getWeeklySituationList();
				}
			});
		},
		addPatrolItemSummary() {
			let _url = "/business/projectweeklyreportfile/addPatrolItemSummary";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: this.recNo,
					workNo: $common.getItem("workNo"),
					beginTime: this.dataForm.beginTime,
					endTime: this.dataForm.endTime
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getWeeklySituationList();
				}
			});
		},
		getProgressKindProgressNoList(dataType) {
			let progressNoList = []
			for (var i = 0; i < this.dataForm.progressKindList.length; i++) {
				let progressKind = this.dataForm.progressKindList[i];
				if (progressKind.dataType == dataType) {
					for (var j = 0; j < progressKind.recordAndTableList.length; j++) {
						let recordAndTable = progressKind.recordAndTableList[j];
						if (recordAndTable.dataKind != undefined && recordAndTable.dataKind != '' && recordAndTable.dataKind == '2'
							&& recordAndTable.showTable != undefined && recordAndTable.showTable != '' && recordAndTable.showTable == '3'
						) {
							// 表格数据
							progressNoList.push(recordAndTable.conProgress.progressNo);
						}
					}
				}
			}
			return progressNoList;
		},
		addProgressKindTableHandle(dataType) {
			let sort = this.getMaxSort(dataType);
			let progressNoList = this.getProgressKindProgressNoList(dataType);
			this.addProgressKindTableVisible = true;
			this.$nextTick(() => {
				this.$refs.addProgressTable.init(this.recNo, sort + 1, dataType, progressNoList)
			})
		},
		addTestItemTableHandle(dataType) {
			let sort = this.getMaxSort(dataType);
			let _url = "/business/projectweeklyreportfile/saveMeetFile";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: '',
					weeklyRecNo: this.recNo,
					dataType: dataType,
					dataKind: '2',
					sourceId: '',
					sourceType: '',
					sort: sort + 1,
					fileName: '',
					updUserName: $common.getItem("userName"),
					sourceType: '',
					showTable: '5',
					sourceId: ''
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getWeeklySituationList();
				}
			});
		},
		addPartolItemTableHandle(dataType) {
			let sort = this.getMaxSort(dataType);
			let _url = "/business/projectweeklyreportfile/saveMeetFile";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: '',
					weeklyRecNo: this.recNo,
					dataType: dataType,
					dataKind: '2',
					sourceId: '',
					sourceType: '',
					sort: sort + 1,
					fileName: '',
					updUserName: $common.getItem("userName"),
					sourceType: '',
					showTable: '6',
					sourceId: ''
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getWeeklySituationList();
				}
			});
		},
		addStopPointTableHandle(dataType) {
			let sort = this.getMaxSort(dataType);
			let _url = "/business/projectweeklyreportfile/saveMeetFile";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: '',
					weeklyRecNo: this.recNo,
					dataType: dataType,
					dataKind: '2',
					sourceId: '',
					sourceType: '',
					sort: sort + 1,
					fileName: '',
					updUserName: $common.getItem("userName"),
					sourceType: '',
					showTable: '1',
					sourceId: ''
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getWeeklySituationList();
				}
			});
		},
		addInspectionTableHandle(dataType) {
			let sort = this.getMaxSort(dataType);
			let _url = "/business/projectweeklyreportfile/saveMeetFile";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: '',
					weeklyRecNo: this.recNo,
					dataType: dataType,
					dataKind: '2',
					sourceId: '',
					sourceType: '',
					sort: sort + 1,
					fileName: '',
					updUserName: $common.getItem("userName"),
					sourceType: '',
					showTable: '2',
					sourceId: ''
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getWeeklySituationList();
				}
			});
		},
		addProgressRecordHandle(dataType) {
			let sort = this.getMaxSort(dataType);
			let _url = "/business/projectweeklyreportfile/saveMeetFile";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: '',
					weeklyRecNo: this.recNo,
					dataType: dataType,
					dataKind: '2',
					sourceId: '',
					sourceType: '',
					sort: sort + 1,
					fileName: '',
					updUserName: $common.getItem("userName"),
					sourceType: '',
					showTable: '4',
					sourceId: ''
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getWeeklySituationList();
				}
			});
		},

		chooseContactHndle(dataType, fileKind) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			// 获取附件监理联系单来源ids
			let fileIds = ''
			// let contactAndNoticeList = this.dataForm.contactAndNoticeList
			// if (contactAndNoticeList != undefined && contactAndNoticeList.length > 0) {
			// 	for (var i = 0; i < contactAndNoticeList.length; i++) {
			// 		if (contactAndNoticeList[i].sourceType === '4' && contactAndNoticeList[i].sourceId != undefined && contactAndNoticeList[i].sourceId != '') {
			// 			fileIds = fileIds + contactAndNoticeList[i].sourceId
			// 			if (i < contactAndNoticeList.length - 1) {
			// 				fileIds = fileIds + ','
			// 			}
			// 		}
			// 	}
			// }
			this.chooseContactVisible = true;
			this.$nextTick(() => {
				this.$refs.chooseContact.init(this.recNo, sort + 1, dataType, fileKind, this.dataForm.beginTime, this.dataForm.endTime, fileIds)
			})
		},
		getEnclosureFileList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectweeklyreportinfo/getEnclosureFileList/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					// this.dataForm.enclosureFileList = data.body
					// 附件列表，重新设置附件名称
					let enclosureFiles = []
					if (data.body != undefined && data.body.length > 0) {
						for (var i = 0; i < data.body.length; i++) {
							data.body[i].fileName = '附件' + (i + 1) + "：" + data.body[i].fileName
							enclosureFiles.push(data.body[i]);
						}
					}
					this.dataForm.enclosureFileList = enclosureFiles;

				}
			});
		},
		uploadEnclosureFile(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadEnclosureFile.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/94/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode == 200) {
					// 计算最大排序值
					let sort = 0;
					let enclosureFileList = this.dataForm.enclosureFileList
					if (enclosureFileList != undefined && enclosureFileList.length > 0) {
						for (var i = 0; i < enclosureFileList.length; i++) {
							if (enclosureFileList[i].sort > sort) {
								sort = enclosureFileList[i].sort
							}
						}
					}

					this.dataForm.enclosureFileList.push({
						filePath: res.body.fileSavePath,
						fileUri: res.body.fileUri,
						fileName: this.extractFileName(res.body.fileName),
						sort: sort + 1,
					});

					// 保存到db中
					let weeklyFileList = []
					let weeklyFile = {
						weeklyRecNo: this.recNo,
						dataKind: '1',
						dataType: "080000",
						subjectNo: '',
						sort: sort + 1,
						fileName: this.extractFileName(res.body.fileName),
						filePath: res.body.fileSavePath,
						sourceType: '',
						sourceId: '',
						updUserName: $common.getItem("userName"),
					}
					weeklyFileList.push(weeklyFile)
					this.saveWeeklyFileList(weeklyFileList, '080000')
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		onDragStart(dataType) {
			this.updateDataType = dataType;
			// this.updateIndex = index;
			// this.updateIndex1 = index1;
			// this.updateIndex2 = index2;
		},
		onDragEnd(event) {
			event.preventDefault();
			// 拖拽结束后的处理逻辑
			let records = [];
			if (this.updateDataType == '010105') {
				// 1.5 本周报验情况
				records = this.dataForm.testItemRecordList
			} else if (this.updateDataType == '010106') {
				// 1.6. 本周巡视情况
				records = this.dataForm.partolItemRecordList
			} else if (this.updateDataType == '010200') {
				// 2.综合情况及重点关注评述
				records = this.dataForm.comSituationList
			} else if (this.updateDataType.startsWith('02')) {
				var progressKindList = this.dataForm.progressKindList;
				for (var i = 0; i < this.dataForm.progressKindList.length; i++) {
					if (this.updateDataType == progressKindList[i].dataType) {
						records = progressKindList[i].recordAndTableList;
					}
				}
			} else if (this.updateDataType == '030100') {
				// 三、本周质量情况  1.停止点检查情况：
				records = this.dataForm.stopPointList
			} else if (this.updateDataType == '030200') {
				// 三、本周质量情况 2.巡检情况：
				records = this.dataForm.inspectionSituationList
			} else if (this.updateDataType == '030300') {
				// 三、本周质量情况 3.监理工作联系单和通知单（不一致项报告）处理及跟踪情况：
				records = this.dataForm.contactAndNoticeList
			} else if (this.updateDataType == '030400') {
				// 三、本周质量情况 4.签收及审查文件情况：
				records = this.dataForm.fileCheckRecords
			} else if (this.updateDataType == '030500') {
				// 三、本周质量情况 5.会议及会谈情况
				records = this.dataForm.meetingList
			} else if (this.updateDataType == '040000') {
				// 四、安全生产/HSE情况
				records = this.dataForm.hseRecordList
			} else if (this.updateDataType == '050000') {
				// 五、监理建议或意见（如需时）
				records = this.dataForm.opinionList
			} else if (this.updateDataType == '060000') {
				// 六、现场人员动态表（如需时）
				records = this.dataForm.onsitePersonalList
			} else if (this.updateDataType == '070000') {
				// 七、下周重点工作计划及安排（如需时）
				records = this.dataForm.keyWorkPlansList
			}
			this.weeklyReportSort(records)
		},
		viewEnclosureFile(url, filename) {
			filename = this.getSuffix(url, filename)
			this.getBlob(url, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		getSuffix(url, filename) {
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		selectContactEnclosureFile() {
			this.contactSelectVisible = true
			// 获取附件监理联系单来源ids
			let fileIds = ''
			let enclosureFileList = this.dataForm.enclosureFileList
			if (enclosureFileList != undefined && enclosureFileList.length > 0) {
				for (var i = 0; i < enclosureFileList.length; i++) {
					if (enclosureFileList[i].dataType === '080000' && enclosureFileList[i].sourceType === '4') {
						fileIds = fileIds + enclosureFileList[i].sourceId
						if (i < enclosureFileList.length - 1) {
							fileIds = fileIds + ','
						}
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.contactSelect.init(this.dataForm.beginTime, this.dataForm.endTime, fileIds)
			})
		},
		margeSelectContactItems(items) {
			this.contactSelectVisible = false;
			// 计算最大排序值
			let sort = 0;
			let enclosureFileList = this.dataForm.enclosureFileList
			if (enclosureFileList != undefined && enclosureFileList.length > 0) {
				for (var i = 0; i < enclosureFileList.length; i++) {
					if (enclosureFileList[i].sort > sort) {
						sort = enclosureFileList[i].sort
					}
				}
			}
			let weeklyFileList = [];
			if (items != undefined && items.length > 0) {
				for (var i = 0; i < items.length; i++) {
					let weeklyFile = {
						weeklyRecNo: this.recNo,
						dataKind: '1',
						dataType: "080000",
						subjectNo: '',
						sort: sort + 1 + i,
						fileName: items[i].fileNo,
						filePath: items[i].filePath,
						sourceType: '4',
						sourceId: items[i].fileId,
						updUserName: $common.getItem("userName"),
					}
					weeklyFileList.push(weeklyFile);
				}
			}
			this.saveWeeklyFileList(weeklyFileList, '080000')
		},
		selectSpecialReportEnclosureFile() {
			this.specialReportSelectVisible = true
			// 获取附件监理联系单来源ids
			let recIds = ''
			let enclosureFileList = this.dataForm.enclosureFileList
			if (enclosureFileList != undefined && enclosureFileList.length > 0) {
				for (var i = 0; i < enclosureFileList.length; i++) {
					if (enclosureFileList[i].dataType === '080000' && enclosureFileList[i].sourceType === '5') {
						recIds = recIds + enclosureFileList[i].sourceId
						if (i < enclosureFileList.length - 1) {
							recIds = recIds + ','
						}
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.specialReportSelect.init(this.dataForm.beginTime, this.dataForm.endTime, recIds)
			})
		},
		margeSelectSpecialReportItems(items) {
			this.specialReportSelectVisible = false;
			// 计算最大排序值
			let sort = 0;
			let enclosureFileList = this.dataForm.enclosureFileList
			if (enclosureFileList != undefined && enclosureFileList.length > 0) {
				for (var i = 0; i < enclosureFileList.length; i++) {
					if (enclosureFileList[i].sort > sort) {
						sort = enclosureFileList[i].sort
					}
				}
			}
			let weeklyFileList = [];
			if (items != undefined && items.length > 0) {
				for (var i = 0; i < items.length; i++) {
					let weeklyFile = {
						weeklyRecNo: this.recNo,
						dataKind: '1',
						dataType: "080000",
						subjectNo: '',
						sort: sort + 1 + i,
						fileName: items[i].fileName,
						filePath: items[i].filePath,
						sourceType: '5',
						sourceId: items[i].recId,
						updUserName: $common.getItem("userName"),
					}
					weeklyFileList.push(weeklyFile);
				}
			}
			this.saveWeeklyFileList(weeklyFileList, '080000')
		},
		selectMeetingHandle(dataType) {
			this.meetingSelectVisible = true
			this.meetDataType = dataType
			// 获取附件监理联系单来源ids
			let meetIds = ''
			// 会议模块
			if (dataType === '030500') {
				let meetingList = this.dataForm.meetingList
				if (meetingList != undefined && meetingList.length > 0) {
					for (var i = 0; i < meetingList.length; i++) {
						if (meetingList[i].sourceId != null && meetingList[i].sourceId != '') {
							meetIds = meetIds + meetingList[i].sourceId
							if (i < meetingList.length - 1) {
								meetIds = meetIds + ','
							}
						}
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.meetingSelect.init(this.dataForm.beginTime, this.dataForm.endTime, meetIds, dataType)
			})
		},
		selectMeetingEnclosureFile(dataType) {
			this.meetingSelectVisible = true
			this.meetDataType = dataType
			// 获取附件监理联系单来源ids
			let meetIds = ''
			// 会议模块
			if (dataType === '080000') {
				let enclosureFileList = this.dataForm.enclosureFileList
				if (enclosureFileList != undefined && enclosureFileList.length > 0) {
					for (var i = 0; i < enclosureFileList.length; i++) {
						if (enclosureFileList[i].dataType === '080000' && enclosureFileList[i].sourceType === '3') {
							meetIds = meetIds + enclosureFileList[i].sourceId
							if (i < enclosureFileList.length - 1) {
								meetIds = meetIds + ','
							}
						}
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.meetingSelect.init(this.dataForm.beginTime, this.dataForm.endTime, meetIds, dataType)
			})
		},
		margeSelectMeetingItems(items) {
			this.meetingSelectVisible = false;
			if (this.meetDataType === '030500') {
				let meetIds = items.map((item) => item.meetId);
				this.saveMeetingFiles(meetIds)
			} else if (this.meetDataType === '080000') {
				// 计算最大排序值
				let sort = 0;
				let enclosureFileList = this.dataForm.enclosureFileList
				if (enclosureFileList != undefined && enclosureFileList.length > 0) {
					for (var i = 0; i < enclosureFileList.length; i++) {
						if (enclosureFileList[i].sort > sort) {
							sort = enclosureFileList[i].sort
						}
					}
				}
				let weeklyFileList = [];
				if (items != undefined && items.length > 0) {
					for (var i = 0; i < items.length; i++) {
						let weeklyFile = {
							weeklyRecNo: this.recNo,
							dataType: "080000",
							dataKind: '1',
							subjectNo: '',
							sort: sort + 1 + i,
							fileName: items[i].meetNumber,
							filePath: items[i].filePath,
							sourceType: '3',
							sourceId: items[i].meetId,
							updUserName: $common.getItem("userName"),
						}
						weeklyFileList.push(weeklyFile);
					}
				}
				this.saveWeeklyFileList(weeklyFileList, '080000')
			}
			this.meetDataType = ''
		},
		selectPhoto() {
			this.selectPhotoVisible = true
			let photoList = this.dataForm.photoList

			// 获取现场照片来源ids
			let recNos = ''
			if (photoList != undefined && photoList.length > 0) {
				for (var i = 0; i < photoList.length; i++) {
					recNos = recNos + photoList[i].sourceId;
					if (i < photoList.length - 1) {
						recNos = recNos + ','
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.photoSelect.init(this.dataForm.beginTime, this.dataForm.endTime, recNos)
			})
		},
		margeSelectPhotoItems(items) {
			let weeklyFileList = [];
			// 计算最大排序值
			let sort = 0;
			let photoList = this.dataForm.photoList
			if (photoList != undefined && photoList.length > 0) {
				for (var i = 0; i < photoList.length; i++) {
					if (photoList[i].sort > sort) {
						sort = photoList[i].sort
					}
				}
			}

			if (items != undefined && items.length > 0) {
				for (var i = 0; i < items.length; i++) {
					let photo = {
						weeklyRecNo: this.recNo,
						dataType: "090000",
						subjectNo: '',
						sort: sort + 1 + i,
						fileName: items[i].photoContent,
						filePath: items[i].photoFilePath,
						compressedPath: items[i].compressedPath,
						sourceType: '1',
						sourceId: items[i].recNo,
						updUserName: $common.getItem("userName"),
					}
					weeklyFileList.push(photo)
				}
			}
			this.saveWeeklyFileList(weeklyFileList, '090000')
		},
		// selectqpPhoto(type, index) {
		// 	this.selectPhotoType = type
		// 	this.selectQPPhotoVisible = true
		// 	this.qpPhotoIndex = index
		// 	let subjectNo;
		// 	let photoList = []
		// 	if (type === '2') {
		// 		// 进度照片
		// 		subjectNo = this.dataForm.progressPhotoList[index].subjectNo;
		// 		photoList = this.dataForm.progressPhotoList[index].photoList
		// 	} else {
		// 		// 质量照片
		// 		subjectNo = this.dataForm.qualityPhotoList[index].subjectNo;
		// 		photoList = this.dataForm.qualityPhotoList[index].photoList
		// 	}

		// 	// 获取现场照片来源ids
		// 	let recNos = ''
		// 	if (photoList != undefined && photoList.length > 0) {
		// 		for (var i = 0; i < photoList.length; i++) {
		// 			recNos = recNos + photoList[i].sourceId;
		// 			if (i < photoList.length - 1) {
		// 				recNos = recNos + ','
		// 			}
		// 		}
		// 	}
		// 	this.$nextTick(() => {
		// 		this.$refs.qpPhotoSelect.init(this.dataForm.beginTime, this.dataForm.endTime, type, subjectNo, recNos)
		// 	})
		// },
		// margeSelectPhotoItems(items) {
		// 	let weeklyFileList = [];
		// 	if (this.selectPhotoType === '2') {
		// 		// 进度照片
		// 		// 计算最大排序值
		// 		let sort = 0;
		// 		let photoList = this.dataForm.progressPhotoList[this.qpPhotoIndex].photoList
		// 		if (photoList != undefined && photoList.length > 0) {
		// 			for (var i = 0; i < photoList.length; i++) {
		// 				if (photoList[i].sort > sort) {
		// 					sort = photoList[i].sort
		// 				}
		// 			}
		// 		}

		// 		if (items != undefined && items.length > 0) {
		// 			for (var i = 0; i < items.length; i++) {
		// 				let progressPhotot = {
		// 					weeklyRecNo: this.recNo,
		// 					dataType: "090100",
		// 					subjectNo: items[i].subjectNo,
		// 					sort: sort + 1 + i,
		// 					fileName: items[i].photoContent,
		// 					filePath: items[i].photoFilePath,
		// 					sourceType: '1',
		// 					sourceId: items[i].recNo
		// 				}
		// 				weeklyFileList.push(progressPhotot)
		// 			}
		// 		}
		// 	} else {
		// 		// 质量照片
		// 		// 计算最大排序值
		// 		let sort = 0;
		// 		let photoList = this.dataForm.qualityPhotoList[this.qpPhotoIndex].photoList
		// 		if (photoList != undefined && photoList.length > 0) {
		// 			for (var i = 0; i < photoList.length; i++) {
		// 				if (photoList[i].sort > sort) {
		// 					sort = photoList[i].sort
		// 				}
		// 			}
		// 		}
		// 		if (items != undefined && items.length > 0) {
		// 			for (var i = 0; i < items.length; i++) {
		// 				let qualityPhoto = {
		// 					weeklyRecNo: this.recNo,
		// 					dataType: "090200",
		// 					subjectNo: items[i].subjectNo,
		// 					sort: sort + 1 + i,
		// 					fileName: items[i].photoContent,
		// 					filePath: items[i].photoFilePath,
		// 					sourceType: '2',
		// 					sourceId: items[i].recNo
		// 				}
		// 				weeklyFileList.push(qualityPhoto)
		// 			}
		// 		}
		// 	}
		// 	this.saveWeeklyFileList(weeklyFileList, '090000')
		// },
		updateImgContent(recNo, photoContent) {
			this.updateImgContentVisable = true;
			this.photoRecNo = recNo;
			this.updatePhotoContent = photoContent;
		},
		headClass() {
			return 'background:#E1F1FF;color:#00428E;border:solid #dadada 1px;padding:1px;font-size:12px'
		},
		saveImgContent() {
			// 直接更新到db
			let _url = "/business/projectweeklyreportfile/updatePhotoContent";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: this.photoRecNo,
					fileName: this.updatePhotoContent
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.updateImgContentVisable = false
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getWeeklySituationList();
				}
			});
		}
	},
};
</script>
<style lang="scss" scoped="scoped">
.elCardTitle {
	color: black !important;
	font-size: 15px;
	border-bottom: 1px solid black;
}

.border-form .el-row.set_border {
	border: solid #dadada 1px;
	border-top: 0px
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 1px;
}

.border-form .el-row.set_border .col-set_border {
	border-right: solid #dadada 1px;
}

.col-set_border1 {
	border: solid #dadada 1px;
}

.col-set_border2 {
	border: solid #dadada 1px;
	border-left: solid #dadada 0px;
}

.col-set_border3 {
	border: solid #dadada 1px;
	border-top: solid #dadada 0px;
}

.col-set_border4 {
	border-right: solid #dadada 1px;
	border-bottom: solid #dadada 1px;
}

.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
	font-size: 13px !important;
}

::v-deep .el-form-item {
	display: flex !important;
	align-items: stretch !important;
	margin-bottom: 0px !important;
}

.summaryLabelspan {
	display: inline-block;
	color: black;
	width: 250px !important;
	padding-left: 10px;
	font-size: 13px;
	margin-bottom: -10px;
	margin-right: 30px;
	margin-left: 5px;
}

.statusSpan {
	width: 232px !important;
	margin-left: 23px
}

.summaryLabelspan1 {
	display: inline-block;
	// margin-left: 10px;
	color: #00428E;
	border: solid #dadada 1px;
	border-bottom: solid #dadada 0px;
	padding-left: 10px;
	font-size: 13px;
	margin-right: 30px;
	// width: 1095%;
}

.contact_col {
	border: 1px solid rgba(235, 238, 240, 1);
	//  border: solid #dadada 1px;
	color: #00428E;
	//  padding-top: -10px !important;
	padding-left: 15px;
	height: 40px;
}

.titleDiv {
	background-color: #E1F1FF;
	font-size: 15px;
	margin-top: 20px;
	margin-bottom: 12px;
	padding: 10px 0px 10px 10px;
	font-weight: bolder;
}

.seTitleDiv {
	font-size: 13px;
	font-weight: bolder;
	margin-left: 10px;
	// border-bottom: 1px solid #E1F1FF;
	background-color: #f9f3f39c;
	// background-color: red;
	height: 30px;
	padding: 7px 0px 5px 5px;
}

::v-deep(.el-form-item__content) {
	flex: 1 !important;
	width: 100% !important;
}

::v-deep(.sp-input) {
	width: 100% !important;
	display: block !important;
	font-size: 13px !important;
}

::v-deep(.sp-input .el-input__inner) {
	width: 100% !important;
	box-sizing: border-box !important;
}

.selBtnGroup {
	margin-top: 5px;
	margin-bottom: 5px;
	margin-right: 20px !important;
}

::v-deep .title_item .el-form-item__content {
	line-height: 25px !important;
}

::v-deep .desc_input .el-input__inner {
	border-radius: 0px;
	border-width: 0px;
	width: 100% !important;
	white-space: pre-wrap !important;
	overflow-wrap: break-word !important;
	// white-space: pre-line !important;
	color: black;
	padding: 0px !important;
	margin-top: -10px;
	font-size: 14px;
	margin-top: 1px;
	// border-bottom: solid #dadada 1px;
}

.desc_span {
	padding-top: 2px;
	line-height: 22px;
	border-bottom: solid transparent 1px;
	white-space: pre-line;
	font-size: 13px;
}

::v-deep .desc_input_color .el-input__inner {
	border-radius: 0px;
	border-width: 0px;
	width: 100% !important;
	white-space: pre-line;
	color: black;
	padding: 0px !important;
	margin-top: -10px;
	font-size: 14px;
	background-color: #e1f1ff !important;
	height: 30px;
}

.un_col {
	border: 1px solid transparent;
	text-align: center;
	margin-top: -5px;
}

.un_span {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: #169BD5;
}

.desc_btn {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: #169BD5;
	margin-top: -8px;
}

.cp_sub_row {
	// border-bottom: 1px solid #00428E;
	font-size: 13px;
	background-color: rgb(204, 247, 176);
	padding: 10px;
	color: #00428E;
}

.cp_maj_row {
	color: #00428E;
	background-color: #a9ccf5;
	padding: 10px;
	border-top: 1px solid #00428E;
}

.cp_sc_div {
	// border: 1px solid rgba(235, 238, 240, 1); 
	// border-bottom: 0px;
	padding: 10px 20px 10px 10px;
	margin-left: 10px;
	margin-top: 5px;
	font-weight: bold;
	font-size: 13px;
	height: 30px;
	display: flex;
	/* 弹性布局 */
	justify-content: space-between;
	/* 左右分开 */
	align-items: center;
	/* 垂直居中 */
}

.el-icon-position {
	margin: 14px;
}

.tr_title_row {
	border: 1px solid rgba(235, 238, 240, 1);
	font-weight: bolder;
	color: #00428E;
	font-size: 14px;
	padding: 15px;
}

.tr_title_row1 {
	font-size: 14px;
	padding: 15px;
}

.tr_qp_row {
	border: 1px solid rgba(235, 238, 240, 1);
	font-weight: bolder;
	font-size: 14px;
	padding: 15px;
	text-align: center
}

.cv_span {
	display: inline-block;
	width: 70px;
	text-align: center;
	background-color: #dadada;
	margin-left: 10px;
	margin-right: 10px;
}

.addImgBox {
	width: 180px;
	height: 180px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 23px;
}

// .image {
// 	width: 80%;
// 	height: 200px;
// 	margin-top: 5px;
// 	display: block;
// }

.photo_row {
	border: 1px solid rgba(235, 238, 240, 1);
	width: 80%;
	padding-bottom: 20px;
	padding-top: 20px;
	margin-top: 10px
}

.meet_row {
	// border: 1px solid rgba(235, 238, 240, 1);
	width: 100%;
	padding-bottom: 20px;
	padding-top: 20px;
	margin-top: 10px
}

.photo_col {
	border: 1px solid rgba(235, 238, 240, 1);
}

.t-column-ellipsis {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;
	padding-bottom: 10px;
	height: 50px;
}

.set_bc {
	border-bottom: solid #dadada 1px;
	background-color: #e1f1ff !important;
	// height:35px !important;
	padding-top: 8px;
	padding-left: 5px;
}

.set_nonS {
	border-bottom: solid #dadada 1px;
	min-height: 28px !important;
	padding-top: 8px;
	padding-left: 5px;
}

.mc_div {
	margin-left: 20px;
	border: 1px solid rgba(235, 238, 240, 1);
	padding: 10px;
	width: 90%;
	margin-bottom: -20px
}

::v-deep .desc_input1 .el-textarea__inner {
	// padding-right: 50px !important;
	border: 0px;
	color: black;
	resize: none;
}

::v-deep .desc_input_bc .el-textarea__inner {
	// padding-right: 50px !important;
	border: 0px;
	color: black;
	background-color: #e1f1ff;
	resize: none;
}

.set_span {
	display: block;
	font-size: 12px !important;
	/* 将span转换为块级元素 */
	max-width: 275px;
	/* 设置固定长度 */
	white-space: nowrap;
	/* 不换行 */
	overflow: hidden;
	/* 超出部分隐藏 */
	text-overflow: ellipsis;
	/* 超出部分显示省略号 */
	cursor: default;
	/* 将鼠标光标设置为默认样式 */
}

.desc_zw {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: white;
}

.sesit {
	margin-left: 15px;
	margin-bottom: 10px;
	margin-top: 10px;
}

/* 表格无数据时：彻底清除所有边框、下划线 */
.no-data-table {
	border: none !important;
}

.no-data-table::before {
	display: none !important;
}

.no-data-table .el-table__empty-block {
	border-bottom: none !important;
}

.no-data-table .el-table__inner-wrapper::before {
	display: none !important;
}

.operate_col {
	margin-left: 3.5%;
}
</style>